"use strict";

angular.module("informaApp")
    .service("HashService", function () {
        return {
            getHashFromIntArray: function(array){
                return (array + "").replace(/(\[|\]|,)/g, "");
            }
        }
    });